export default "__VITE_ASSET__D_yu4fMu__"